import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckoutButton } from './CheckoutButton';

/** Floating mobile checkout bar, revealed once the hero is scrolled past. */
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 640);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-224" data-mp="3uc3w7n59pmdp">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: 'easeOut'
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-orangey-100 bg-white/95 px-4 py-3 backdrop-blur-md sm:hidden" data-id="element-225" data-mp="3glgtzl0atecv">
          <CheckoutButton size="md" className="w-full !text-base" data-id="element-226" data-mp="gyiko5ezw8o8">
            Build My Dog's Plan — $29
          </CheckoutButton>
          <p className="mt-1.5 text-center font-mono text-[0.62rem] uppercase tracking-[0.14em] text-ink-400" data-id="element-227" data-mp="73t4t0wgfa8q">
            Instant access · One-time payment · No subscription
          </p>
        </motion.div>}
    </AnimatePresence>;
}